
<div class="numberspinner">
  <span class="numberspinner__btn" (click)="decrement();"></span>
  <div class="numberspinner__view">{{ value }}</div>
  <span class="numberspinner__btn" (click)="increment();"></span>
</div>
